export default __webpack_public_path__ + "static/media/check_off.c17490e7.svg";